import HOME_ICON from "../../resources/icons/home-icon.png";
import PRODUCT_ICON from "../../resources/icons/product-icon.png";
import LITERATURE_ICON from "../../resources/icons/literature-icon.png";
import SERVICE_ICON from "../../resources/icons/service-ticket-icon.png";
import TRAINING_ICON from "../../resources/icons/training-icon.png";
import { getOfflineData } from "../../utils/offline-services";
import { USER_LIMITS, USER_ROLES } from "../../utils/constants";
import { checkForUserLimit } from "../../utils";
const OEM_START_HOME = [
  {
    name: "Home",
    id: 1,
    icon: HOME_ICON,
    url: "/oem",
  },
];
const OEM_HO_DASHBOARD = [
  { name: "Overview", id: 17, url: "/oem/dashboard", icon: HOME_ICON },
];
const OEM_TABS = [
  {
    name: "Product",
    id: 2,
    icon: PRODUCT_ICON,
    children: [
      {
        name: "Portfolio",
        id: 2.1,
        url: "/oem/products",
      },
      {
        name: "Power Range",
        id: 2.2,
        url: "/oem/products/power-range",
      },
    ],
  },
  {
    name: "Parts Catalogue",
    id: 21,
    icon: PRODUCT_ICON,
    url: "/oem/parts-catalogue",
  },
  {
    name: "Literature",
    id: 3,
    icon: LITERATURE_ICON,
    children: [
      {
        name: "Workshop Manual",
        id: 3.1,
        url: "/oem/literature/workshop-manual",
      },
      {
        name: "Service Information",
        id: 3.2,
        url: "/oem/literature/service-info",
      },
      {
        name: "Service Bulletins",
        id: 3.3,
        url: "/oem/literature/service-bulletins",
      },
    ],
  },
  {
    name: "Service Support",
    id: 4,
    icon: SERVICE_ICON,
    children: [
      {
        name: "Create Service Ticket",
        id: 4.1,
        url: "/oem/create-ticket",
        disabled: true,
      },
      {
        name: "FOC",
        id: 4.2,
        url: `/oem/foc-form/:ticketId`,
        disabled: true,
      },
    ],
    url: "/oem/service-support",
  },
  {
    name: "Training",
    id: 5,
    icon: TRAINING_ICON,
    children: [
      {
        name: "Training Modules",
        id: 5.0,
        url: "/oem/training/training-module",
      },
      {
        name: "Calendar",
        id: 5.1,
        url: "/oem/training/training-year-view",
      },
      {
        name: "Approval Status",
        id: 5.2,
        url: "/oem/training/training-approval-status",
      },
    ],
  },

  {
    name: "Claims",
    id: 6,
    icon: TRAINING_ICON,
    url: "/oem/claims",
  },
];
const COMMON_ADMIN_START_TABS = [
  {
    name: "Dashboard",
    id: 1,
    icon: HOME_ICON,
    children: [
      { name: "Overview", id: 1.1, url: "/admin" },
      {
        name: "Engine Replacement Trend",
        id: 1.2,
        url: "/admin/engine-replacement-trend",
      },
      {
        name: "MIS",
        id: 1.3,
        url: "/admin/mis",
      },
      {
        name: "Float Enigne Dashboard",
        url: "/admin/float-engine-dashboard",
        id: 1.4,
      },
      // {
      //   name: "Training Dashboard",
      //   id: 1.3,
      //   url: "/admin/training-dashboard",
      // },
    ],
  },
  /*  {
    name: "Tickets",
    id: 2,
    icon: HOME_ICON,
    url: "/admin/tickets",
  },
  {
    name: "Overview",
    id: 3,
    icon: HOME_ICON,
    url: "/admin/overview",
  }, */
];
const COMMON_ADMIN_END_TABS = [
  {
    name: "Setup",
    id: 15,
    icon: HOME_ICON,
    url: "/admin/setup",
  },
  // {
  //   name: "Reports",
  //   id: 5,
  //   icon: HOME_ICON,
  //   url: "/admin/reports",
  // },
];
const ADMIN_TABS = [
  /*  {
    name: "Reports",
    id: 5,
  }, */
  {
    name: "Tickets",
    id: 2,
    icon: SERVICE_ICON,
    children: [
      {
        id: 2.1,
        url: "/admin/details/:id",
        disabled: true,
      },
    ],
    url: "/admin/tickets",
  },
  {
    name: "Engineer Movement",
    id: 11,
    icon: HOME_ICON,
    url: "/admin/engineer-movement",
  },
  {
    name: "Training",
    id: 16,
    icon: TRAINING_ICON,
    children: [
      {
        name: "Training Modules",
        id: 16.0,
        url: "/admin/training/training-module",
      },
      {
        name: "Calendar",
        id: 16.1,
        url: "/admin/training/training-year-view",
      },
      {
        name: "Training Approvals",
        id: 16.2,
        url: "/admin/training/training-approval",
      },
      {
        name: "Training Report",
        id: 16.3,
        url: "/admin/training-reports",
      },
      {
        name: "Training Plan VS Actual",
        id: 16.4,
        url: "/admin/training/training-plan-vs-actual",
      },
    ],
  },
  {
    name: "Analysis",
    id: 8,
    icon: HOME_ICON,
    children: [
      {
        id: 8.1,
        url: "/admin/failed-engine-analysis",
        name: "Failed Engine Analysis",
      },
      {
        id: 8.2,
        url: "/admin/failed-part-analysis",
        name: "Failed Parts Analysis",
      },
      {
        id: 8.3,
        url: "/admin/ica",
        name: "ICA/CAPA",
      },
      {
        id: 8.4,
        url: "/admin/invoice-engine-details",
        name: "Invoice Engine Details",
      },
    ],
  },
  {
    name: "Event",
    id: 18,
    icon: HOME_ICON,
    children: [
      {
        id: 18.1,
        url: "/admin/infant-care-tracking",
        name: "Infant Care Tracking",
      },
      {
        name: "Export Engine Tracking",
        id: 18.2,
        icon: TRAINING_ICON,
        url: "/admin/export-engine-tracking",
      },
      {
        name: "Knowledge Sharing",
        id: 18.3,
        url: "/admin/knowledge-sharing",
      },
    ],
  },
  {
    name: "Literatures",
    id: 6,
    icon: LITERATURE_ICON,
    children: [
      {
        id: 6.1,
        url: "/admin/wsm",
        name: "Workshop Manual",
      },
      {
        id: 6.2,
        url: "/admin/service-info",
        name: "Service Information",
      },
      {
        id: 6.3,
        url: "/admin/service-bulletins",
        name: "Service Bulletins",
      },
      {
        id: 6.4,
        url: "/admin/internal-cutin",
        name: "Internal Cut in",
      },
      {
        id: 6.5,
        url: "/admin/faq",
        name: "FAQ",
      },
    ],
  },

  {
    name: "Claims",
    id: 12,
    icon: PRODUCT_ICON,
    children: [
      {
        name: "OEM Claims",
        id: 12.1,
        url: "/admin/warranty-claims",
      },
      {
        name: "SAP Claims",
        id: 12.2,
        url: "/admin/sap-claims",
      },
    ],
  },
  ...COMMON_ADMIN_END_TABS,
];

const FLOAT_ENGINE_MANAGER_TABS = [
  {
    name: "Float engine movements",
    id: 7,
    icon: HOME_ICON,
    children: [
      {
        name: "Float engine movements",
        id: 7.1,
        url: "/admin/float-engine-movement",
      },
      {
        name: "Float engine Inward",
        id: 7.2,
        url: "/admin/float-engine-Inward",
      },
      {
        name: "Advance Engine Replacement",
        id: 7.3,
        url: "/admin/advance-engine-replacement",
      },
      {
        name: "SAP Float Engines",
        id: 7.4,
        url: "/admin/stock-details",
      },
    ],
  },
];
const APPROVER_TABS = [
  {
    name: "Pending Requests",
    id: 9,
    icon: HOME_ICON,
    url: "/admin/pending-requests",
  },
];
const SERVICE_ENGINEER = [
  {
    name: "Tickets",
    id: 2,
    icon: HOME_ICON,
    children: [
      {
        id: 2.1,
        url: "/admin/details/:id",
        disabled: true,
      },
    ],
    url: "/admin/tickets",
  },
];
// const QUALITY = [
//   {
//     name: "Float Engines",
//     id: 10,
//     icon: HOME_ICON,
//     url: "/admin/float-engines",
//   },
// ];
const QUALITY_CREATOR = [
  {
    name: "Analysis",
    id: 19,
    icon: HOME_ICON,
    children: [
      {
        id: 19.1,
        url: "/admin/failed-engine-analysis",
        name: "Failed Engine Analysis",
      },
      {
        id: 19.2,
        url: "/admin/failed-part-analysis",
        name: "Failed Parts Analysis",
      },
      {
        id: 19.3,
        url: "/admin/ica",
        name: "ICA/CAPA",
      },
    ],
  },
];
const QUALITY_APPROVER = [
  {
    name: "Pending Requests",
    id: 13,
    icon: HOME_ICON,
    url: "/admin/quality-pending-requests",
  },
];
const QUALITY_ADMIN = [
  {
    name: "Service Tickets",
    id: 14,
    icon: HOME_ICON,
    children: [
      {
        id: 14.1,
        url: "/admin/details/:id",
        disabled: true,
      },
    ],
    url: "/admin/tickets",
  },
];
export const getNavigationTabs = () => {
  const { role, limits, admin } = getOfflineData("user");
  switch (role) {
    case USER_ROLES.OEM:
      let oemTabs = [...OEM_TABS];
      if (!admin) {
        oemTabs = oemTabs.filter(tab => tab.name !== "Claims");
      }
      if (admin) {
        return [...OEM_START_HOME, ...OEM_HO_DASHBOARD, ...oemTabs];
      } else {
        return [...OEM_START_HOME, ...oemTabs];
      }
    case USER_ROLES.ADMIN:
      const userTypeBaseTabs = () => {
        let arr = [];
        if (checkForUserLimit(USER_LIMITS.FLOAT_ENGINE_MANAGER, limits)) {
          arr = [...arr, ...FLOAT_ENGINE_MANAGER_TABS];
        }
        if (checkForUserLimit(USER_LIMITS.APPROVER, limits)) {
          arr = [...arr, ...APPROVER_TABS];
        }
        if (checkForUserLimit(USER_LIMITS.ADMIN, limits)) {
          arr = [...arr, ...ADMIN_TABS];
        }
        if (checkForUserLimit(USER_LIMITS.SERVICE_ENGINEER, limits)) {
          arr = [...arr, ...SERVICE_ENGINEER];
        }
        // if (checkForUserLimit(USER_LIMITS.QUALITY, limits)) {
        //   arr = [...arr, ...QUALITY];
        // }
        if (checkForUserLimit(USER_LIMITS.QUALITY_CREATOR, limits)) {
          arr = [...arr, ...QUALITY_CREATOR];
        }
        if (checkForUserLimit(USER_LIMITS.QUALITY_APPROVER, limits)) {
          arr = [...arr, ...QUALITY_APPROVER];
        }
        if (checkForUserLimit(USER_LIMITS.QUALITY_ADMIN, limits)) {
          arr = [...arr, ...QUALITY_ADMIN];
        }
        // arr = [...arr, ...ADMIN_TABS];
        return arr;
      };

      return [
        ...COMMON_ADMIN_START_TABS,
        ...userTypeBaseTabs(),
        // ...COMMON_ADMIN_END_TABS,
      ];
    default:
      return [];
  }
};
